/**
 * Cria um objeto HTMLImageElement a partir de uma URL.
 */
export const createImage = (url) =>
    new Promise((resolve, reject) => {
        const image = new Image()
        image.addEventListener('load', () => resolve(image))
        image.addEventListener('error', (error) => reject(error))
        image.setAttribute('crossOrigin', 'anonymous')
        image.src = url
    })

/**
 * Retorna o ângulo em radianos.
 */
export function getRadianAngle(degreeValue) {
    return (degreeValue * Math.PI) / 180
}

/**
 * Retorna a imagem cortada como um Blob.
 */
export default async function getCroppedImg(imageSrc, pixelCrop, rotation = 0, outputWidth = null, outputHeight = null) {
    const image = await createImage(imageSrc)
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')

    const safeArea = Math.max(image.width, image.height) * 2

    // Configurações para suportar rotação segura
    canvas.width = safeArea
    canvas.height = safeArea

    // Translação para o centro
    ctx.translate(safeArea / 2, safeArea / 2)
    ctx.rotate(getRadianAngle(rotation))
    ctx.translate(-safeArea / 2, -safeArea / 2)

    // Desenha a imagem rotacionada
    ctx.drawImage(
        image,
        safeArea / 2 - image.width * 0.5,
        safeArea / 2 - image.height * 0.5
    )

    const data = ctx.getImageData(0, 0, safeArea, safeArea)

    // Define o tamanho final do canvas
    // Se outputWidth/Height forem fornecidos, usa eles. Se não, usa o tamanho do crop.
    canvas.width = outputWidth || pixelCrop.width
    canvas.height = outputHeight || pixelCrop.height

    // Cria um segundo canvas temporário para o crop puro se precisarmos redimensionar
    const cropCanvas = document.createElement('canvas');
    cropCanvas.width = pixelCrop.width;
    cropCanvas.height = pixelCrop.height;
    const cropCtx = cropCanvas.getContext('2d');

    cropCtx.putImageData(
        data,
        0 - safeArea / 2 + image.width * 0.5 - pixelCrop.x,
        0 - safeArea / 2 + image.height * 0.5 - pixelCrop.y
    );

    // Agora desenha o cropCanvas no canvas final (com resize se necessário)
    const finalCtx = canvas.getContext('2d');
    // Limpa (opcional pois setar width já limpa)
    // finalCtx.clearRect(0,0, canvas.width, canvas.height); // desnecessário

    // Usa drawImage para escalar do cropCanvas para o canvas final
    finalCtx.drawImage(cropCanvas, 0, 0, pixelCrop.width, pixelCrop.height, 0, 0, canvas.width, canvas.height);

    // Retorna como Blob
    return new Promise((resolve) => {
        canvas.toBlob((blob) => {
            if (!blob) {
                console.error('Canvas is empty');
                return;
            }
            // Adiciona nome para simular arquivo se necessário
            blob.name = 'cropped.jpeg';
            resolve(blob);
        }, 'image/jpeg', 0.9); // Qualidade JPEG 0.9
    })
}
